import { useSelector } from 'react-redux';

import { selectIsRestrictedMode } from '@/store/selectors/userSelectors';

// True when the current user is in restricted mode (Alberta on ROC — see
// selectIsRestrictedMode). Consumers gate deposits, bonuses, the rewards wheel,
// and force play-for-fun on this. Migration modals are owned by #2119, not this.
export function useRestrictedMode(): boolean {
  return useSelector(selectIsRestrictedMode);
}
